import React, { useEffect } from 'react'
import Loadable from 'react-loadable'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import Connector from 'utils/connector'
import { colors } from 'theme'
import Layout from 'components/Layout'

import * as ROUTES from './constants/routes/Routes'

const Auth = Loadable({
  loader: () => import('./containers/auth'),
  loading: () => <div />,
})

const Home = Loadable({
  loader: () => import('./containers/home'),
  loading: () => <div />,
})

const CreateAuction = Loadable({
  loader: () => import('./containers/create-auction'),
  loading: () => <div />,
})

const Dashboard = Loadable({
  loader: () => import('./containers/dashboard'),
  loading: () => <div />,
})

const AuctionDetails = Loadable({
  loader: () => import('./containers/auctionDetails'),
  loading: () => <div />,
})

const AuctionSearch = Loadable({
  loader: () => import('./containers/auction-search'),
  loading: () => <div />,
})

const Router = ({ checked, loggedIn }) => {
  // update css variables
  useEffect(() => {
    Object.keys(colors).forEach(key => {
      const cssKey = `--${key}`
      const cssVal = colors[key]
      document.body.style.setProperty(cssKey, cssVal)
    })
  }, [])

  if (!checked) return <aside>Loading...</aside>
  // TODO: Refactor to <Link to="">
  return (
    <BrowserRouter>
      {loggedIn ? (
        <Switch>
          <Route
            path={ROUTES.CREATE_AUCTION}
            name="Create Auction"
            render={props => (
              <Layout {...props}>
                <CreateAuction {...props} />
              </Layout>
            )}
          />
          <Route
            path={ROUTES.SEARCH_AUCTION}
            name="Auction Search"
            render={props => (
              <Layout {...props}>
                <AuctionSearch {...props} />
              </Layout>
            )}
          />
          <Route
            path={ROUTES.DASHBOARD}
            name="Dashboard"
            render={props => (
              <Layout {...props}>
                <Dashboard {...props} />
              </Layout>
            )}
          />
          <Route
            path={ROUTES.AUCTION}
            name="Auction"
            render={props => (
              <Layout {...props}>
                <AuctionDetails {...props} />
              </Layout>
            )}
          />
          <Route
            path={ROUTES.HOME}
            name="Home"
            render={props => (
              <Layout {...props}>
                <Home {...props} />
              </Layout>
            )}
          />
          <Redirect to="/" />
        </Switch>
      ) : (
        <Switch>
          <Route path="/" component={Auth} />
          <Redirect to="/" />
        </Switch>
      )}
    </BrowserRouter>
  )
}

export default props => (
  <Connector>
    {({
      state: {
        app: { loggedIn, checked, user },
      },
    }) => (
      <Router checked={checked} loggedIn={loggedIn} user={user} {...props} />
    )}
  </Connector>
)
